import styled from 'styled-components'
import ConnectWalletButton from './ConnectWalletButton'

const ErrorConnectButton = styled(ConnectWalletButton)`
  background-color: ${({ theme }) => theme.colors.named.red};
`

export default ErrorConnectButton
